import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLSHOOTINGSTAR', label: 'Shooting Star', lookback: 11 })
